// Attach files to an issue

function attachFiles(image, selector) {
  const form = $('.' + selector + '__attachments-form');
  const button = $(
    '<input type="file" name="files[]"' + (image ? ' accept="image/*" capture="camera"' : ' multiple="multiple"') + '/>'
  ).appendTo(form);
  button.on('change', function () {
    updateFilesToAttach(selector);
  });
  button.trigger('click');
}

// Update the number of files that will be attached

function updateFilesToAttach(selector) {
  const nr = getFilesToAttachAmount(selector);
  $('.' + selector + '__add-attachments-indicator')[nr === 0 ? 'removeClass' : 'addClass']('add-attachments-active');
  $('.' + selector + '__add-attachments-count').html(nr === 1 ? __('attachmentsNotice1File') : __('attachmentsNoticeNFiles', [nr]));
}

function getFilesToAttachAmount(selector) {
  let nr = 0;
  $('.' + selector + '__attachments-form input[type="file"]').each(function (index, item) {
    nr += item.files.length;
  });
  return nr;
}

// Clear the files that have been selected to be attached

function clearFilesToAttach(selector) {
  $('.' + selector + '__attachments-form').html('');
  updateFilesToAttach(selector);
}

// Update the number of attachments an issue has

function updateIssueAttachmentAmount(nr, selector) {
  $('.' + selector + '__attachments')[nr ? 'removeClass' : 'addClass']('textfield-button--disabled');
  $('.' + selector + '__attachments-count').html(nr || 0);
}

// Update the number of attachments an issue has

function uploadFiles(issueId, callbackSuccess, callbackError) {
  $.ajax({
    url: settings.apiEndpoint + '/api/files',
    type: 'POST',
    headers: {
      apiToken: settings.apiToken,
      issueId: issueId
    },
    data: new FormData($('.edit-issue__attachments-form')[0]),
    cache: false,
    contentType: false,
    processData: false,
    success: function (response) {
      clearFilesToAttach('edit-issue');
      callbackSuccess && callbackSuccess();
    },
    error: function (response) {
      callbackError && callbackError();
    },
    xhr: function () {
      var myXhr = $.ajaxSettings.xhr();
      if (myXhr.upload) {
        myXhr.upload.addEventListener(
          'progress',
          function (e) {
            if (e.lengthComputable) {
              // console.log(e.loaded, e.total);
              const button = $('#create-issue__modal-save-button');
              const percent = Math.floor((e.loaded / e.total) * 100);
              const text =
                'Uploading files (' + formatBytes(e.loaded, 2) + ' / ' + formatBytes(e.total, 2) + ') ' + percent + '%';
              setButtonLoadingStatus(button, text, percent);
            }
          },
          false
        );
      }
      return myXhr;
    }
  });
}

// Init the edit attachments tooltip

function initEditAttachmentsTooltip(attachTo) {
  if (!attachTo) {
    attachTo = '.edit-issue__attachments';
  }

  if (app.editAttachmentsTooltip) {
    app.editAttachmentsTooltip.attach();
    return;
  }

  app.editAttachmentsTooltip = new jBox('Tooltip', {
    addClass: 'edit-issue__attachments-tooltip',
    attach: attachTo,
    theme: 'TooltipBorder',
    position: {
      y: 'top',
      x: 'right'
    },
    outside: 'y',
    offset: {
      x: -51 + 8,
      y: 0
    },
    maxHeight: 342,
    pointer: 'right:38',
    trigger: 'click',
    zIndex: 10000 + 100,
    createOnInit: true,
    closeOnClick: 'body',
    width: 520 - 8 - 4,
    content: '<div class="edit-issue__attachments-tooltip-content"></div>',
    onOpen: function () {
      this.source && this.source.addClass('attachment-tooltip-open');
    },
    onClose: function () {
      this.source && this.source.removeClass('attachment-tooltip-open');
    }
  });
}

// Delete an attachment

function deleteAttachment(id) {
  $.ajax({
    url: settings.apiEndpoint + '/api/file',
    type: 'DELETE',
    headers: {
      apiToken: settings.apiToken
    },
    data: {
      id: id
    },
    beforeSend: function () {
      $('.edit-attachment__container[data-id="' + id + '"] .edit-attachment__button')
        .addClass('loading-bar')
        .attr('disabled', 'disabled');
    },
    success: function (response) {
      $('.edit-attachment__container[data-id="' + id + '"] .edit-attachment__button').removeClass('loading-bar');
      if (!response || !response.success) {
        $('.edit-attachment__container[data-id="' + id + '"] .edit-attachment__button').removeAttr('disabled');
        return error();
      }
      $('.edit-attachment__container[data-id="' + id + '"]').fadeOut(200, function () {
        $('.edit-attachment__container[data-id="' + id + '"]').remove();

        $('.edit-issue__attachments-count').html(parseInt($('.edit-issue__attachments-count').html() - 1));
        $('.protocol-item-modal__attachments-count').html(
          parseInt($('.protocol-item-modal__attachments-count').html() - 1)
        );

        if (!$('.edit-attachment__container').length) {
          $('.edit-issue__attachments-tooltip-content').html(
            '<div class="show-issue-modal__attachments-content--empty">' +
              __('attachmentsNoticeNoAttachments') +
              '</div>'
          );
          app.editAttachmentsTooltip.close();
        }
        app.editAttachmentsTooltip && app.editAttachmentsTooltip.position();
      });
    },
    error: function () {
      $('.edit-attachment__container[data-id="' + id + '"] .edit-attachment__button')
        .removeClass('loading-bar')
        .removeAttr('disabled');
      error();
    }
  });
}

// Issue lightbox

$(function () {
  app.imageModal = new jBox('Image', {
    attach: '.attachment-image',
    gallery: 'attachments',
    zIndex: 11000,
    imageLabel: 'data-title'
  });
});
